// extracted by mini-css-extract-plugin
module.exports = {"container":"PercentageInput_container__27qcS","bar":"PercentageInput_bar__1ZOmB","percents":"PercentageInput_percents__2CkhO"};